import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_1106 implements Validator {

    public static id = 'CTRL_1106';
    private message = 'error.ctr_1106';


    public LOG: LogService = new LogService(CTRL_1106);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1106.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLotMarche = rg.substr(rg.length - 1);
                const firstChamp = ctrl.value.rgCtrls.firstChamp.replace('INDEX_1106_1', numLotMarche);
                const secondChamp = ctrl.value.rgCtrls.secondChamp.replace('INDEX_1106_1', numLotMarche);

                const firstChampNameWithStepId = map.get(firstChamp);
                const secondChampNameWithStepId = map.get(secondChamp);

                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                if (firstChampCtrl !== undefined && secondChampCtrl !== undefined) {
                    if (firstChampCtrl.value >= secondChampCtrl.value) {
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                    } else {
                        // placer le message d'erreur
                        form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                    }
                }
                
            }
        }
    }
}